module.exports = __webpack_public_path__ + "static/media/interactivo4.e4fb47d6.png";